import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { Tooltip } from 'antd';
import { realTimeModeOnTrendsSelector } from '@store/common/selectors';
import { dimensionTableHeaderIntervalSelector } from '@src/store/dimensionTables/selectors';
import { noBrushSelector } from '@store/trends/birdChart/selectors';
import { formatInterval } from './utils/format';
import { Interval, StyledInfo } from './styled';

const IntervalLabel = ({ interval }) => {
  const [isNote, setIsNote] = useState(true);
  const toolTipText =
    'The system automatically adjusts the time-boundaries when an area is selected in the hourly time-series graph for more than 31 days in the past. This is because Conviva keeps only hourly data points for > 31 days. The auto-adjustment happens by fetching the data for the “hourly data points” which are within the selected area. For example, if the area selected is 9:15-10:45, the system will fetch the data for 10th hour, which in turn is the aggregation of 10:00-10:59.';
  const liveMode = useSelector(realTimeModeOnTrendsSelector);
  const dimensionHeaderInterval = useSelector(dimensionTableHeaderIntervalSelector);
  const isNoBrushSelected = useSelector(noBrushSelector);

  useEffect(() => {
    if (moment().diff(interval.from, 'days') > 31) {
      setIsNote(true);
    } else {
      setIsNote(false);
    }
  }, [interval]);

  const headerInterval =
    liveMode && isNoBrushSelected && dimensionHeaderInterval ? dimensionHeaderInterval : interval;

  return (
    <Interval>
      {isNote ? (
        <Tooltip title={toolTipText}>
          <StyledInfo>Auto Adjusted : </StyledInfo>
        </Tooltip>
      ) : null}
      {formatInterval(headerInterval, liveMode)}
    </Interval>
  );
};

export default IntervalLabel;
